/* STARKFELD Hilfe-Launcher (2026-09-24, Stand 4: eigener KI-Chat)
 *
 * Elemente mit [data-sf-help-launcher] (Support-Karte in der Buybox und
 * Aktionszeile im FAQ-Kontaktblock, beide snippets/sf-support-card.liquid,
 * sowie der schlichte Link im share-Block) fuehren zu Hilfe. Der Modus steht
 * in data-sf-help-mode:
 *
 *   "chat"   Nur sichtbar, wenn ein KI-Chat wirklich da ist: der Microsoft
 *            Brand Agent ODER der eigene STARK AI (window.sfChat mit
 *            available === true, Signal "sfchat:ready" auf window, siehe
 *            assets/sf-chat-widget.js). Microsoft hat Vorrang, wenn beide da
 *            sind; oeffnet er nicht, uebernimmt der eigene Chat.
 *            Microsoft: #ads-agent-host mit Launcher im offenen Shadow-DOM
 *            ([data-testid="entrypoint"] [role="button"]). Erkennung beim Laden,
 *            per MutationObserver (Dokument + Shadow-Root des Hosts) und ueber
 *            die Events brandagent:active / brandagent:ready / brandagent:shown.
 *            Gefunden -> data-sf-chat="available" auf allen
 *            [data-sf-support-actions]-Containern (CSS blendet den Chat-Button
 *            ein und macht ihn primaer, Ticket wird sekundaer).
 *            Klick: Launcher klicken, bis 1500 ms auf brandagent:shown warten.
 *            Oeffnet der Chat wider Erwarten nicht: Chat-Button fuer diese
 *            Sitzung ausblenden (sessionStorage), Fokus auf "Ticket eroeffnen",
 *            KEIN Drawer.
 *   "ticket" Hilfe-Drawer #HelpDrawer (sections/help-drawer.liquid) oeffnen,
 *            erstes Feld fokussieren. Ohne Drawer: Liegt der Button in einem
 *            Kontaktformular (FAQ-Block), dessen erstes Feld fokussieren (kein
 *            Scrollsprung), sonst zum naechsten [id^="ContactForm-"] scrollen
 *            und fokussieren, sonst href bzw. data-sf-help-href aufrufen.
 *   (leer)   Textlink im share-Block: Agent wenn vorhanden, sonst eigener
 *            KI-Chat, sonst Drawer.
 *            Traegt der Link aria-controls="HelpDrawer", oeffnet theme.js den
 *            Drawer selbst; hier werden nur die versteckten Felder gefuellt.
 *
 * Der Drawer wird mit drawer.show(launcher) geoeffnet, damit theme.js
 * (ModalElement.afterHide -> removeTrapFocus(activeElement)) den Fokus beim
 * Schliessen (Escape, Overlay, Close-Button, Wischgeste) auf den ausloesenden
 * Button zuruecksetzt. Enter/Space auf <button>, Enter auf <a> loesen click aus.
 *
 * Versteckte Felder contact[Produkt]/[Variante]/[Quelle] werden vor dem Oeffnen
 * gefuellt. ?sf_ticket=1 oeffnet den Drawer nach dem Laden (Quelle "KI-Chat");
 * [data-sf-help-open] (Liquid nach Erfolg/Fehler) oeffnet ihn ebenfalls und
 * fokussiert die Statusmeldung.
 *
 * Keine Abhaengigkeiten. Laden mit defer nach theme.js.
 */
(function () {
  'use strict';

  if (window.__sfHelpLauncher) return;

  var LAUNCHER_SELECTOR = '[data-sf-help-launcher]';
  var ACTIONS_SELECTOR = '[data-sf-support-actions]';
  var TICKET_SELECTOR = '[data-sf-help-launcher][data-sf-help-mode="ticket"]';
  var DRAWER_ID = 'HelpDrawer';
  var FORM_ID = 'ContactForm-HelpDrawer';
  var AGENT_HOST_ID = 'ads-agent-host';
  var AGENT_SHOWN_EVENT = 'brandagent:shown';
  var AGENT_EVENTS = ['brandagent:active', 'brandagent:ready', 'brandagent:loaded', 'brandagent:shown'];
  var AGENT_TIMEOUT_MS = 1500;
  var OWN_CHAT_READY_EVENT = 'sfchat:ready';
  var CHAT_FAILED_KEY = 'sfHelpChatFailed';
  var SOURCE_BUYBOX = 'Buybox';
  var SOURCE_CHAT = 'STARK AI';
  var FIELD_SELECTOR = 'input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled])';

  var pending = false;
  var chatAvailable = false;
  var chatFailed = false;
  var hostObserver = null;
  var docObserver = null;
  var checkTimer = null;

  try {
    chatFailed = window.sessionStorage && window.sessionStorage.getItem(CHAT_FAILED_KEY) === '1';
  } catch (error) {}

  function byId(id) {
    return document.getElementById(id);
  }

  /* ---------- Hilfe-Drawer (theme.js drawer-element) ---------- */

  function getDrawer() {
    var drawer = byId(DRAWER_ID);
    return drawer && typeof drawer.show === 'function' ? drawer : null;
  }

  function getForm() {
    return byId(FORM_ID);
  }

  function isDrawerOpen(drawer) {
    return !!drawer && drawer.hasAttribute('open');
  }

  /* ---------- Microsoft Brand Agent (Shadow-DOM) ---------- */

  function getAgentHost() {
    var host = byId(AGENT_HOST_ID);
    return host && host.shadowRoot ? host : null;
  }

  function getAgentLauncher() {
    var host = getAgentHost();
    if (!host) return null;

    var root = host.shadowRoot;
    var launcher = root.querySelector('[data-testid="entrypoint"] [role="button"]');
    if (launcher) return launcher;

    var candidates = root.querySelectorAll('[role="button"]');
    for (var i = 0; i < candidates.length; i++) {
      var label = candidates[i].getAttribute('aria-label') || '';
      if (label.indexOf('Einkaufshilfe') !== -1 || label.indexOf('KI-Chat') !== -1) {
        return candidates[i];
      }
    }
    return null;
  }

  function agentLooksOpen() {
    var host = getAgentHost();
    if (!host) return false;
    var entrypoint = host.shadowRoot.querySelector('[data-testid="entrypoint"]');
    if (entrypoint && entrypoint.getAttribute('data-collapsed') === 'false') return true;
    return !!host.shadowRoot.querySelector('[role="dialog"]');
  }

  function tryAgent(launcher) {
    return new Promise(function (resolve) {
      var settled = false;
      var timer = null;

      function finish(shown) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        window.removeEventListener(AGENT_SHOWN_EVENT, onShown);
        document.removeEventListener(AGENT_SHOWN_EVENT, onShown);
        resolve(shown);
      }

      function onShown() {
        finish(true);
      }

      window.addEventListener(AGENT_SHOWN_EVENT, onShown);
      document.addEventListener(AGENT_SHOWN_EVENT, onShown);
      timer = window.setTimeout(function () {
        finish(agentLooksOpen());
      }, AGENT_TIMEOUT_MS);

      try {
        launcher.click();
      } catch (error) {
        finish(false);
      }
    });
  }

  /* ---------- Eigener KI-Chat (STARK AI) ---------- */

  function getOwnChat() {
    var chat = window.sfChat;
    return chat && chat.available === true && typeof chat.open === 'function' ? chat : null;
  }

  function openOwnChat(launcher) {
    var chat = getOwnChat();
    if (!chat) return false;
    try {
      chat.open(launcher || null);
      return true;
    } catch (error) {
      return false;
    }
  }

  function chatUsable() {
    return (chatAvailable && !chatFailed) || !!getOwnChat();
  }

  /* ---------- Feature-Erkennung: Chat-Button nur mit echtem Chat ---------- */

  function syncActions() {
    var containers = document.querySelectorAll(ACTIONS_SELECTOR);
    for (var i = 0; i < containers.length; i++) {
      if (chatUsable()) {
        containers[i].setAttribute('data-sf-chat', 'available');
      } else {
        containers[i].removeAttribute('data-sf-chat');
      }
    }
  }

  function observeHost() {
    var host = getAgentHost();
    if (!host || hostObserver || typeof MutationObserver !== 'function') return;
    hostObserver = new MutationObserver(scheduleCheck);
    hostObserver.observe(host.shadowRoot, { childList: true, subtree: true, attributes: true });
  }

  function checkAgent() {
    checkTimer = null;
    if (chatFailed) return;
    observeHost();
    var available = !!getAgentLauncher();
    if (available === chatAvailable) return;
    chatAvailable = available;
    syncActions();
    if (available) stopWatching();
  }

  function scheduleCheck() {
    if (checkTimer) return;
    checkTimer = window.setTimeout(checkAgent, 150);
  }

  function stopWatching() {
    if (docObserver) {
      docObserver.disconnect();
      docObserver = null;
    }
    if (hostObserver) {
      hostObserver.disconnect();
      hostObserver = null;
    }
  }

  function startWatching() {
    window.addEventListener(OWN_CHAT_READY_EVENT, syncActions);
    syncActions();
    if (chatFailed) return;
    checkAgent();
    if (chatAvailable) return;
    if (typeof MutationObserver === 'function') {
      docObserver = new MutationObserver(scheduleCheck);
      docObserver.observe(document.documentElement, { childList: true, subtree: true });
    }
    for (var i = 0; i < AGENT_EVENTS.length; i++) {
      window.addEventListener(AGENT_EVENTS[i], scheduleCheck);
      document.addEventListener(AGENT_EVENTS[i], scheduleCheck);
    }
    window.addEventListener('load', scheduleCheck, { once: true });
  }

  function markAgentFailed() {
    chatFailed = true;
    chatAvailable = false;
    try {
      if (window.sessionStorage) window.sessionStorage.setItem(CHAT_FAILED_KEY, '1');
    } catch (error) {}
    stopWatching();
    syncActions();
  }

  function disableChat(launcher) {
    markAgentFailed();

    var container = launcher && typeof launcher.closest === 'function' ? launcher.closest(ACTIONS_SELECTOR) : null;
    var ticket = container ? container.querySelector(TICKET_SELECTOR) : document.querySelector(TICKET_SELECTOR);
    focusElement(ticket, true);
  }

  /* ---------- Kontext: Produkt, Variante, Quelle ---------- */

  function readVariantMap() {
    var script = document.querySelector('script[data-sf-help-variants]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function readProductTitle() {
    var explicit = document.querySelector('[data-product-title]');
    if (explicit) {
      var value = explicit.getAttribute('data-product-title') || explicit.textContent;
      if (value && value.trim()) return value.trim();
    }
    var heading = document.querySelector('.product__title h1, .product__title .h1, h1');
    if (heading && heading.textContent.trim()) return heading.textContent.trim().replace(/\s+/g, ' ');
    return (document.title || '').trim();
  }

  function readVariantId(launcher) {
    var scope = launcher && typeof launcher.closest === 'function'
      ? (launcher.closest('.shopify-section') || document)
      : document;
    var input = scope.querySelector('form[action*="/cart/add"] [name="id"]')
      || document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return String(input.value);

    try {
      var fromUrl = new URLSearchParams(window.location.search).get('variant');
      if (fromUrl) return fromUrl;
    } catch (error) {}

    return '';
  }

  function readVariantTitle(launcher) {
    var map = readVariantMap();
    var variantId = readVariantId(launcher);
    if (map && variantId && map[variantId]) return map[variantId];
    return '';
  }

  function setHiddenField(form, name, value, overwrite) {
    var field = form.querySelector('input[type="hidden"][name="contact[' + name + ']"]');
    if (!field) return;
    if (value && (overwrite || !field.value)) field.value = value;
  }

  function fillContext(launcher, source) {
    var form = getForm();
    if (!form) return;
    setHiddenField(form, 'Produkt', readProductTitle(), false);
    setHiddenField(form, 'Variante', readVariantTitle(launcher), true);
    if (source) setHiddenField(form, 'Quelle', source, true);
  }

  /* ---------- Fokus ---------- */

  function focusElement(element, preventScroll) {
    if (!element || typeof element.focus !== 'function') return;
    try {
      element.focus({ preventScroll: !!preventScroll });
    } catch (error) {
      element.focus();
    }
  }

  function firstField(scope) {
    var field = scope.querySelector(FIELD_SELECTOR);
    if (field && field.type === 'radio') {
      var checked = scope.querySelector('input[type="radio"][name="' + field.name + '"]:checked');
      if (checked) field = checked;
    }
    return field;
  }

  function focusInDrawer(drawer, mode) {
    var form = getForm();
    var scope = form || drawer;
    if (mode === 'status') {
      var status = scope.querySelector('[data-sf-help-open]');
      if (status) {
        if (!status.hasAttribute('tabindex')) status.setAttribute('tabindex', '-1');
        focusElement(status, false);
        try {
          status.scrollIntoView({ block: 'nearest' });
        } catch (error) {}
        return;
      }
    }
    focusElement(firstField(scope), false);
  }

  /* ---------- Drawer oeffnen ---------- */

  function openDrawer(launcher, source, focusMode) {
    var drawer = getDrawer();
    if (!drawer) return false;

    fillContext(launcher, source);

    var afterShow = function () {
      focusInDrawer(drawer, focusMode);
    };

    if (isDrawerOpen(drawer)) {
      afterShow();
      return true;
    }

    drawer.addEventListener('drawer:afterShow', afterShow, { once: true });
    try {
      drawer.show(launcher || null);
    } catch (error) {
      drawer.removeEventListener('drawer:afterShow', afterShow);
      return false;
    }
    return true;
  }

  /* ---------- Kontaktformular auf Seiten ohne Drawer ---------- */

  function focusOwnForm(launcher) {
    var form = launcher && typeof launcher.closest === 'function' ? launcher.closest('form[id^="ContactForm-"]') : null;
    if (!form) return false;
    var field = firstField(form);
    if (!field) return false;
    focusElement(field, true);
    try {
      field.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } catch (error) {}
    return true;
  }

  function scrollToContactForm() {
    var form = document.querySelector('form[id^="ContactForm-"]') || document.querySelector('[id^="ContactForm-"]');
    if (!form) return false;

    try {
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (error) {
      form.scrollIntoView();
    }

    var field = firstField(form);
    if (field) {
      window.setTimeout(function () {
        focusElement(field, true);
      }, 450);
    }
    return true;
  }

  function navigate(launcher) {
    if (!launcher) return;
    var href = launcher.getAttribute('href') || launcher.getAttribute('data-sf-help-href');
    if (!href) return;
    if (launcher.getAttribute('target') === '_blank') {
      window.open(href, '_blank', 'noopener');
    } else {
      window.location.href = href;
    }
  }

  function openTicket(launcher, source) {
    if (openDrawer(launcher, source, 'field')) return;
    if (focusOwnForm(launcher)) return;
    if (scrollToContactForm()) return;
    navigate(launcher);
  }

  /* ---------- Klick auf einen Launcher ---------- */

  function onClick(event) {
    if (event.defaultPrevented) return;
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var launcher = target.closest(LAUNCHER_SELECTOR);
    if (!launcher) return;
    if (typeof event.button === 'number' && event.button !== 0) return;
    if (launcher.hasAttribute('href') && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;

    var mode = (launcher.getAttribute('data-sf-help-mode') || '').toLowerCase();
    var agentLauncher = getAgentLauncher();
    var drawer = getDrawer();
    var themeOpensDrawer = !!drawer && launcher.getAttribute('aria-controls') === DRAWER_ID;

    if (mode === 'ticket') {
      event.preventDefault();
      event.stopPropagation();
      openTicket(launcher, SOURCE_BUYBOX);
      return;
    }

    if (mode === 'chat') {
      event.preventDefault();
      event.stopPropagation();
      if (pending) return;
      if (!agentLauncher || chatFailed) {
        if (openOwnChat(launcher)) return;
        disableChat(launcher);
        return;
      }
      pending = true;
      launcher.setAttribute('aria-busy', 'true');
      tryAgent(agentLauncher).then(function (shown) {
        pending = false;
        launcher.removeAttribute('aria-busy');
        if (shown) return;
        if (getOwnChat()) {
          markAgentFailed();
          openOwnChat(launcher);
          return;
        }
        disableChat(launcher);
      });
      return;
    }

    /* Ohne Modus (schlichter Textlink im share-Block) */
    if (agentLauncher && !chatFailed) {
      event.preventDefault();
      event.stopPropagation();
      if (pending) return;
      pending = true;
      tryAgent(agentLauncher).then(function (shown) {
        pending = false;
        if (shown) return;
        if (openOwnChat(launcher)) return;
        openTicket(launcher, SOURCE_BUYBOX);
      });
      return;
    }

    if (getOwnChat()) {
      event.preventDefault();
      event.stopPropagation();
      openOwnChat(launcher);
      return;
    }

    if (themeOpensDrawer) {
      fillContext(launcher, SOURCE_BUYBOX);
      if (!isDrawerOpen(drawer)) {
        drawer.addEventListener('drawer:afterShow', function () {
          focusInDrawer(drawer, 'field');
        }, { once: true });
      }
      return;
    }

    event.preventDefault();
    openTicket(launcher, SOURCE_BUYBOX);
  }

  document.addEventListener('click', onClick, true);

  /* ---------- Automatisch oeffnen nach dem Laden ---------- */

  function stripTicketParam() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('sf_ticket')) return;
      url.searchParams.delete('sf_ticket');
      window.history.replaceState(window.history.state, '', url.pathname + (url.search || '') + url.hash);
    } catch (error) {}
  }

  function autoOpen() {
    var viaChat = false;
    try {
      viaChat = new URLSearchParams(window.location.search).get('sf_ticket') === '1';
    } catch (error) {}

    var drawerElement = byId(DRAWER_ID);
    var posted = drawerElement ? drawerElement.querySelector('[data-sf-help-open]') : null;
    if (!viaChat && !posted) return;

    var open = function () {
      window.setTimeout(function () {
        var opened = openDrawer(null, viaChat ? SOURCE_CHAT : null, posted ? 'status' : 'field');
        if (opened && viaChat) stripTicketParam();
      }, 350);
    };

    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('drawer-element').then(open, open);
    } else {
      open();
    }
  }

  function init() {
    startWatching();
    autoOpen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.__sfHelpLauncher = {
    open: function (source) {
      return openDrawer(null, source || SOURCE_BUYBOX, 'field');
    },
    tryAgent: function () {
      var launcher = getAgentLauncher();
      return launcher ? tryAgent(launcher) : Promise.resolve(false);
    },
    check: function () {
      checkAgent();
      syncActions();
      return chatUsable();
    },
    isChatAvailable: function () {
      return chatUsable();
    }
  };
})();
